import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allLgvsOfThisPlant: [],
  navQualityHeatmapIsEnabled: false,
  navHeatmapTimeFrames: {},
  convertedNavHeatmapData: null,
  navHeatmapLoader: true,
  navLevel2Data: {},
  navLevel1Data: {},
  navLevel0Data: {},
  isLevel3ApiComplete: false
};

const navHeatmapSlice = createSlice({
  name: "navHeatmap",
  initialState,
  reducers: {
    setAllLgvsOfThisPlant: (state, action) => {
      state.allLgvsOfThisPlant = action.payload;
    },
    setNavQualityHeatmapIsEnabled: (state, action) => {
      state.navQualityHeatmapIsEnabled = action.payload;
    },
    setNavHeatmapTimeFrames: (state, action) => {
      state.navHeatmapTimeFrames = action.payload;
    },
    setConvertedNavHeatmapData: (state, action) => {
      state.convertedNavHeatmapData = action.payload;
    },
    setNavHeatmapLoader: (state, action) => {
      state.navHeatmapLoader = action.payload;
    },
    setNavLevel2Data: (state, action) => {
      state.navLevel2Data = action.payload;
    },
    setNavLevel1Data: (state, action) => {
      state.navLevel1Data = action.payload;
    },
    setNavLevel0Data: (state, action) => {
      state.navLevel0Data = action.payload;
    },
    setIsLevel3ApiComplete: (state, action) => {
      state.isLevel3ApiComplete = action.payload;
    }
  }
});

export const {
  setAllLgvsOfThisPlant,
  setNavQualityHeatmapIsEnabled,
  setNavHeatmapTimeFrames,
  setConvertedNavHeatmapData,
  setNavHeatmapLoader,
  setNavLevel2Data,
  setNavLevel1Data,
  setNavLevel0Data,
  setIsLevel3ApiComplete
} = navHeatmapSlice.actions;

export default navHeatmapSlice.reducer;
